module.exports = __webpack_public_path__ + "static/media/ИНФОРМАЦИОННОЕ ПИСЬМО №2.38c15444.pdf";